<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">
      <!-- TITLE-->
      <div class="row mb-3">
        <div class="col-md-12">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <h1 class="typography-headline-lg fw-500">Team</h1>
          </vue-aos>
          <p class="subtitle-1 text-muted mb-1">You have a question? Send us a message</p>
        </div>
      </div>

      <!-- TEAM CARDS -->
      <div class="row mb-5">
        <div class="col-md-4 mb-3">
          <div class="card card-outline translate-up">
            <div class="card-body text-center">
              <img src="@/assets/img/logos/gian-indigo.png" class="img-fluid border-radius-50 mb-3"
                   width="100px" alt="user avatar">
              <h2 class="typography-headline-md fw-500">Giancarlos Garza</h2>
              <h3 class="subtitle-1 text-muted">Co-Founder | Front End</h3>
              <hr>
              <a href="https://twitter.com/giangzadev" class="text-underline me-3" title="Twitter" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/twitter-fill.svg"
                     alt="Twitter">
              </a>
              <a href="https://github.com/giancarlosgza" class="text-underline me-3" title="GitHub" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/github-fill.svg"
                     alt="GitHub">
              </a>
              <a href="https://codepen.io/giancarlosgza" class="text-underline me-3" title="Codepen" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/codepen.svg"
                     alt="Codepen">
              </a>
              <a href="https://giangza.dev/?ref=colorffy" class="text-underline me-3" title="GianGza website"
                 target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/vuejs-fill.svg"
                     alt="GianGza website">
              </a>
              <a href="https://www.youtube.com/channel/UCaDDlTA0MRnC59jwLpC0s-Q/featured" class="text-underline me-3" title="YouTube"
                 target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/youtube-fill.svg"
                     alt="YouTube">
              </a>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="card card-outline translate-up">
            <div class="card-body text-center">
              <img src="@/assets/img/logos/eli-normal.jpeg" class="img-fluid border-radius-50 mb-3"
                   width="100px" alt="user avatar">
              <h2 class="typography-headline-md fw-500">Carlos Eli Lopez</h2>
              <h3 class="subtitle-1 text-muted">Co-Founder | Developer</h3>
              <hr>
              <a href="https://twitter.com/elilopezdev" class="text-underline me-3" title="Twitter" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/twitter-fill.svg"
                     alt="Twitter">
              </a>
              <a href="https://github.com/Serveix" class="text-underline me-3" title="GitHub" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/github-fill.svg"
                     alt="GitHub">
              </a>
              <a href="https://www.youtube.com/c/serveix/featured" class="text-underline me-3" title="YouTube"
                 target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/youtube-fill.svg"
                     alt="YouTube">
              </a>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="card card-outline translate-up">
            <div class="card-body text-center">
              <img src="https://github.com/AAbbnneerr.png" class="img-fluid border-radius-50 mb-3"
                   width="100px" alt="user avatar">
              <h2 class="typography-headline-md fw-500">Abner Anzures</h2>
              <h3 class="subtitle-1 text-muted">Icon Designer</h3>
              <hr>
              <a href="https://twitter.com/AbnerAnzures" class="text-underline me-3" title="Twitter" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/twitter-fill.svg"
                     alt="Twitter">
              </a>
              <a href="https://github.com/AAbbnneerr" class="text-underline me-3" title="GitHub" target="_blank"
                 rel="noopener">
                <img class="img-fluid img-logo"
                     src="@/assets/img/icons/github-fill.svg"
                     alt="GitHub">
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-center flex-wrap">
                <img src="@/assets/img/logos/products/gitkraken-ambassador-logo.png" class="img-fluid me-3 mb-3 mb-xl-0"
                     width="125px"
                     height="125px" alt="GitKraken ambassador logo">
                <div>
                  <p class="paragraph text-body fw-500 mb-1">We are GitKraken ambassadors</p>
                  <p class="paragraph mb-2">
                    Also if you want to give a try and start using GitKraken, you can click down below and download it!
                  </p>
                  <a href="https://www.gitkraken.com/invite/gqVVLWVF" class="btn btn-primary ripple px-3 mx-0"
                     target="_blank" rel="noopener">
                    Download from here</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA SECTION -->
      <ProjectsCTA></ProjectsCTA>

    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import ProjectsCTA from "@/components/cta/ProjectsCTA";
import VueAos from 'vue-aos'

export default {
  name: 'Team',
  metaInfo: {
    title: 'Team',
  },
  components: {ProjectsCTA, Footer, Navbar, VueAos}
}
</script>